/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ReportReferenceDate = {
    Current: 'current',
    Previous: 'previous',
    Preprevious: 'preprevious'
} as const;
export type ReportReferenceDate = typeof ReportReferenceDate[keyof typeof ReportReferenceDate];


export function instanceOfReportReferenceDate(value: any): boolean {
    for (const key in ReportReferenceDate) {
        if (Object.prototype.hasOwnProperty.call(ReportReferenceDate, key)) {
            if (ReportReferenceDate[key as keyof typeof ReportReferenceDate] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ReportReferenceDateFromJSON(json: any): ReportReferenceDate {
    return ReportReferenceDateFromJSONTyped(json, false);
}

export function ReportReferenceDateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportReferenceDate {
    return json as ReportReferenceDate;
}

export function ReportReferenceDateToJSON(value?: ReportReferenceDate | null): any {
    return value as any;
}

export function ReportReferenceDateToJSONTyped(value: any, ignoreDiscriminator: boolean): ReportReferenceDate {
    return value as ReportReferenceDate;
}

